import axios from "axios";
import API_CONFIG from "../config/api";
import { getAuthHeaders } from "../utils/auth";



const projectService = {
    // Get all projects
    getAllProjects: async (params = {}) => {
        try {
            const response = await axios.get(`${API_CONFIG.BASE_URL}/projects`, { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get project by slug
    getProjectBySlug: async (slug) => {
        try {
            const response = await axios.get(`${API_CONFIG.BASE_URL}/projects/${slug}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new project
    createProject: async (projectData) => {
        try {
            const response = await axios.post(
                `${API_CONFIG.BASE_URL}/projects`,
                projectData,
                { headers: getAuthHeaders() }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update project
    updateProject: async (id, projectData) => {
        try {
            const response = await axios.put(
                `${API_CONFIG.BASE_URL}/projects/${id}`,
                projectData,
                { headers: getAuthHeaders() }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete project
    deleteProject: async (id) => {
        try {
            const response = await axios.delete(
                `${API_CONFIG.BASE_URL}/projects/${id}`,
                { headers: getAuthHeaders() }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get total count of projects
    getProjectCount: async () => {
        try {
            const response = await axios.get(`${API_CONFIG.BASE_URL}/projects`, {
                params: { limit: 1 }
            });
            // Check pagination.total first, then fall back to data array length
            return response.data.pagination?.total || response.data.data?.length || 0;
        } catch (error) {
            console.error('Error fetching project count:', error);
            return 0;
        }
    }
};

export default projectService;
